import { FC } from "react";
import { Alert, Box, Typography } from "@mui/material";

import { RiInformationLine } from "react-icons/ri";

import {
  Claim,
  EdiObject,
  FeeChange,
  ManualPaymentFields,
} from "../../../../../types/claims";
import { SummaryRow } from "../record-payment/ClaimEditDialogParts";
import PaymentEffect from "../record-payment/PaymentEffect";
import {
  describeManualPayment,
  getManualPaymentFields,
} from "../record-payment/manualPayments";
import { getPaidAmountAfterJoin, getRemitFields } from "./joinPayments";

const PaymentSection: FC<{ title: string; fields: ManualPaymentFields }> = ({
  title,
  fields,
}) => (
  <Box>
    <Typography
      sx={{
        fontSize: "0.75rem",
        fontWeight: 700,
        color: "text.secondary",
        letterSpacing: "0.03em",
        textTransform: "uppercase",
      }}
    >
      {title}
    </Typography>
    {describeManualPayment(fields).map((row) => (
      <SummaryRow key={row.label} label={row.label}>
        {row.value}
      </SummaryRow>
    ))}
  </Box>
);

/**
 * The join's confirmation: both payments, what joining does to the claim (from
 * the dry run) and that it can't be undone. Hidden behind `blocked` when the API
 * refused the dry run, so only the refusal shows.
 */
const JoinPaymentConfirm: FC<{
  claim: Claim;
  manual: EdiObject;
  remit: EdiObject;
  fee: FeeChange | null;
  blocked: boolean;
}> = ({ claim, manual, remit, fee, blocked }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    {!blocked && (
      <Alert
        severity="warning"
        icon={<RiInformationLine size={20} />}
        sx={{ maxWidth: "100%" }}
      >
        This can't be undone.
      </Alert>
    )}

    <Typography sx={{ fontSize: "0.8125rem", color: "text.secondary" }}>
      The 835 becomes the payment of record and the manual payment stops
      counting, so the payment counts once. Its correspondence stays on the 835.
    </Typography>

    <PaymentSection
      title="Manual payment"
      fields={getManualPaymentFields(manual)}
    />
    <PaymentSection title="835 remit" fields={getRemitFields(remit)} />

    {!blocked && (
      <PaymentEffect
        claim={claim}
        fee={fee}
        paidAmountAfter={getPaidAmountAfterJoin(claim, manual)}
      />
    )}
  </Box>
);

export default JoinPaymentConfirm;
